import request from "@/utils/request.js";

/**
 * 获取用户加入的机构
 * @param params
 * @returns {AxiosPromise}
 */
export function listUserJoinOrg(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/listUserJoinOrg",
    method: "post",
    data: params
  });
}

/**
 * 绑定机构
 * @param params
 * @returns {AxiosPromise}
 */
export function bindOrgId(params) {
  return request({
    url: "/userService/api/app/user/nurse/login/bindOrgId",
    method: "post",
    data: params
  });
}

/**
 * 是否加入机构(v3.0)
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserIsJoinTypeV30(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/getUserIsJoinTypeV30",
    method: "post",
    data: params
  });
}
